<app-toast />

<app-card-content [border]="false" [title]="'E-mail Automático'" [subtitle]="'Configuração do servidor SMTP para o envio automático de e-mails do sistema'" [icon]="'pi pi-envelope'">
    <div card-header class="flex items-center gap-2">
        <p-button label="Enviar Teste" icon="pi pi-send" severity="secondary" [text]="true" styleClass="whitespace-nowrap" [disabled]="carregando() || !configExiste()" (onClick)="abrirDialogTeste()" [appCan]="roleEmailEditar" />
        <p-button label="Salvar" icon="pi pi-check" severity="primary" [loading]="salvando()" [disabled]="carregando()" (onClick)="salvar()" [appCan]="roleEmailEditar" />
    </div>

    <div class="max-w-4xl pt-5 pb-8">
        <app-card-container [hoverEfect]="false">
            <div class="flex flex-col gap-8">
                <!-- Info strip -->
                <div class="flex items-center gap-3 px-4 py-3 rounded-xl bg-surface-50 dark:bg-surface-800 border border-surface-100 dark:border-surface-700 text-xs text-surface-500 dark:text-surface-400">
                    <i class="pi pi-info-circle text-primary shrink-0"></i>
                    <span>Configure o servidor SMTP para envio de e-mails automáticos do sistema. A senha não é exibida por segurança — informe apenas para cadastrar ou alterar.</span>
                </div>

                @if (carregando()) {
                    <div class="flex items-center gap-3 text-sm text-surface-400">
                        <i class="pi pi-spin pi-spinner"></i>
                        <span>Carregando configurações...</span>
                    </div>
                } @else {
                    <!-- Conexão -->
                    <div class="flex flex-col gap-4">
                        <div class="flex items-center gap-2 pb-2.5 border-b border-surface-100 dark:border-surface-700">
                            <i class="pi pi-server text-primary text-xs"></i>
                            <span class="text-[10px] font-black text-surface-500 dark:text-surface-400 uppercase tracking-[0.15em]">Conexão</span>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <div class="flex flex-col gap-1.5 md:col-span-3">
                                <label class="text-[10px] font-bold uppercase tracking-widest ml-0.5" [class]="hostInvalido() ? 'text-red-500' : 'text-surface-400 dark:text-surface-500'"> Host SMTP * </label>
                                <input
                                    pInputText
                                    type="text"
                                    placeholder="smtp.servidor.com.br"
                                    [ngModel]="host()"
                                    (ngModelChange)="host.set($event); hostInvalido.set(false)"
                                    class="font-mono"
                                    [class.ng-invalid]="hostInvalido()"
                                    [class.ng-dirty]="hostInvalido()"
                                />
                                @if (hostInvalido()) {
                                    <small class="text-red-500 text-xs ml-0.5">Campo obrigatório</small>
                                }
                            </div>
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5"> Porta </label>
                                <p-inputnumber [ngModel]="porta()" (ngModelChange)="porta.set($event)" [useGrouping]="false" placeholder="587" inputStyleClass="font-mono w-full" />
                            </div>
                        </div>
                    </div>

                    <!-- Credenciais -->
                    <div class="flex flex-col gap-4">
                        <div class="flex items-center gap-2 pb-2.5 border-b border-surface-100 dark:border-surface-700">
                            <i class="pi pi-lock text-primary text-xs"></i>
                            <span class="text-[10px] font-black text-surface-500 dark:text-surface-400 uppercase tracking-[0.15em]">Credenciais</span>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5"> Usuário (login) </label>
                                <input pInputText type="text" placeholder="usuário@domínio.org.br" [ngModel]="username()" (ngModelChange)="username.set($event)" class="font-mono" />
                            </div>
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5"> Senha </label>
                                <p-password
                                    [ngModel]="password()"
                                    (ngModelChange)="password.set($event)"
                                    [toggleMask]="true"
                                    [feedback]="false"
                                    [placeholder]="configExiste() ? '••••••••  (deixe em branco para manter)' : 'Senha do servidor'"
                                    class="w-full"
                                    inputStyleClass="w-full font-mono"
                                />
                            </div>
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label class="text-[10px] font-bold uppercase tracking-widest ml-0.5" [class]="senderAddressInvalido() ? 'text-red-500' : 'text-surface-400 dark:text-surface-500'"> E-mail remetente * </label>
                            <input
                                pInputText
                                type="email"
                                placeholder="naoresponder@portalmedico.org.br"
                                [ngModel]="senderAddress()"
                                (ngModelChange)="senderAddress.set($event); senderAddressInvalido.set(false)"
                                class="font-mono"
                                [class.ng-invalid]="senderAddressInvalido()"
                                [class.ng-dirty]="senderAddressInvalido()"
                            />
                            @if (senderAddressInvalido()) {
                                <small class="text-red-500 text-xs ml-0.5">Campo obrigatório</small>
                            }
                        </div>
                    </div>

                    <!-- Avançado -->
                    <div class="flex flex-col gap-4">
                        <div class="flex items-center gap-2 pb-2.5 border-b border-surface-100 dark:border-surface-700">
                            <i class="pi pi-sliders-h text-primary text-xs"></i>
                            <span class="text-[10px] font-black text-surface-500 dark:text-surface-400 uppercase tracking-[0.15em]">Avançado</span>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5"> Protocolo </label>
                                <p-select
                                    [appendTo]="'body'"
                                    [options]="protocolOptions"
                                    [ngModel]="protocol()"
                                    (ngModelChange)="protocol.set($event)"
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Selecione o protocolo"
                                    class="w-full"
                                    styleClass="w-full"
                                />
                            </div>
                            <div class="flex flex-col gap-3 justify-center">
                                <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5"> Autenticação </label>
                                <div class="flex items-center gap-2">
                                    <p-toggleswitch [ngModel]="auth()" (ngModelChange)="auth.set($event)" />
                                    <span class="text-sm text-surface-600 dark:text-surface-300">{{ auth() ? 'Habilitada' : 'Desabilitada' }}</span>
                                </div>
                            </div>
                            <div class="flex flex-col gap-3 justify-center">
                                <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5"> STARTTLS </label>
                                <div class="flex items-center gap-2">
                                    <p-toggleswitch [ngModel]="starttls()" (ngModelChange)="starttls.set($event)" />
                                    <span class="text-sm text-surface-600 dark:text-surface-300">{{ starttls() ? 'Habilitado' : 'Desabilitado' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </app-card-container>
    </div>
</app-card-content>

<!-- Dialog: e-mail de teste -->
<p-dialog appDialogoPadrao="pi pi-envelope" descricao="Confirma se as credenciais SMTP funcionam." header="Enviar E-mail de Teste" [visible]="dialogTeste()" (visibleChange)="dialogTeste.set($event)" [style]="{ width: '420px' }">
    <div class="flex flex-col gap-4 py-2">
        <p class="text-sm text-surface-500 dark:text-surface-400 m-0">Informe o endereço de destino para validar a configuração SMTP atual.</p>
        <div class="flex flex-col gap-1.5">
            <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5"> Destinatário </label>
            <input pInputText type="email" placeholder="destinatario@exemplo.com.br" [ngModel]="emailDestino()" (ngModelChange)="emailDestino.set($event)" class="font-mono" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" [text]="true" (onClick)="dialogTeste.set(false)" />
        <p-button label="Enviar" icon="pi pi-send" [loading]="enviandoTeste()" (onClick)="enviarEmailTeste()" [appCan]="roleEmailEditar" />
    </ng-template>
</p-dialog>
